import {CategoryEdit} from "./CategoryEdit";

export default {
    edit: CategoryEdit,
};
